import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import React from 'react';
interface Props {
  isLeftSide: boolean;
  onClick: () => void;
}

export const ScrollDataView: React.FC<Props> = ({ isLeftSide, onClick }) => (
  <div
    className={`absolute top-[10px] h-[83%] bg-blue-600 text-blue-600 bg-opacity-50 opacity-80 z-10 flex items-center cursor-pointer ${
      isLeftSide ? 'left-16' : 'right-0'
    }`}
    onClick={onClick}
  >
    {isLeftSide ? <ChevronLeft /> : <ChevronRight />}
  </div>
);
